import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'document-card',
  standalone: false,
  templateUrl: './document-card.component.html',
  styleUrl: './document-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentCardComponent<T> {
}
